import { Filter, FilterType } from '../../search.filter/search-filter.component';

export const configuredFilters: Filter[] = [
  {
    type: FilterType.TEXTWITHOR,
    name: 'name',
    label: 'Name',
    group: 'Admin',
  },
  {
    type: FilterType.TEXTWITHOR,
    name: 'email',
    label: 'Email',
    group: 'Admin',
  },
  {
    type: FilterType.SELECT,
    name: 'role',
    label: 'Role',
    options: [],
    group: 'Admin',
  },
];
